<template lang="pug">
  div 
    v-btn(@click="$refs.imUpload.click()") Choose image to upload 
    v-progress-circular(
      v-if="uploadStarted && uploadStatus == 'starting'"
      indeterminate
      color="green")
    v-icon(v-if= "uploadStatus == 'success'" color="success") done
    input.hide(type="file" ref="imUpload" @change="onFileSelected")
</template>
<script>
//TODO  add feedback for successful upload, add thumbnail preview (hint small canvas)
export default {
  name: 'ImageUpload',
  data: () => ({
    selectedFile:null,
    uploadStarted: false
  }),
  computed:{
    uploadStatus: function (){
      return this.$store.state.uploadStatus
    }
  },
  methods: {
    onFileSelected (event) {
      this.uploadStarted = true
      this.selectedFile = event.target.files[0]
      this.$store.dispatch('uploadImage', this.selectedFile)
    }
  }

}
</script>
<style scoped>
.hide{
  display: none;
}
</style>


